import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const CopyIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 16 16"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M4.42 0.73V1.46H14.17C14.39 1.46 14.54 1.61 14.54 1.83V11.58C14.54 11.8 14.39 11.95 14.17 11.95H4.42C4.2 11.95 4.05 11.8 4.05 11.58V1.83C4.05 1.61 4.2 1.46 4.42 1.46V0.73V-0C3.4 -0 2.59 0.8 2.59 1.83V11.58C2.59 12.6 3.4 13.41 4.42 13.41H14.17C15.2 13.41 16 12.6 16 11.58V1.83C16 0.8 15.2 -0 14.17 -0H4.42V0.73Z"
				fill="white"
			/>
			<path
				d="M11.69 14.58H1.72C1.57 14.58 1.46 14.47 1.46 14.32V4.31C1.46 3.91 1.13 3.58 0.73 3.58C0.33 3.58 0 3.91 0 4.31V14.28C0 15.23 0.77 16 1.72 16H11.69C12.09 16 12.42 15.67 12.42 15.27C12.42 14.9 12.09 14.58 11.69 14.58Z"
				fill="white"
			/>
		</svg>
	)
}

export default CopyIcon
